import type { AuthTokens } from '@xiangqi/protocol';

const STORAGE_KEY = 'xq_session_v1';

export interface StoredSession {
  access_token: string;
  refresh_token: string;
  user: AuthTokens['user'];
}

export function loadSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as StoredSession) : null;
  } catch {
    return null;
  }
}

export function saveSession(tokens: AuthTokens): StoredSession {
  const session: StoredSession = {
    access_token: tokens.access_token,
    refresh_token: tokens.refresh_token,
    user: tokens.user,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch {
    // Private mode etc. — session just won't survive a reload.
  }
  return session;
}

export function clearSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
